<template>
    <div class="dashboard">
        <template>
            <el-card style='padding:0px 5px 0px 5px' v-loading="rowLoading">
                <div style='width:49%;padding-right:1%;float:left;border-right:1px dashed #ccc;'>
                    <h5 class='mb5'><i class='el-icon-lx-infofill red size20'></i> 整体数据</h5>
                    <el-row   :gutter="5" type="flex" justify="space-between">
                        <el-col :span="12" >
                            <div class="card-container">
                                <el-card class="top-card">
                                    <div class="card-content">
                                        <i class="el-icon-lx-roundcheckfill icon" ></i>
                                        <div class="text-content iconJump">
                                            <div class="card-value" v-animate-number="tsData.successNum"></div>
                                            <div class="card-title">订购量</div>
                                        </div>
                                    </div>
                                </el-card>
                                <div class="hover-layer"></div>
                            </div>
                        </el-col>
                        <el-col :span="12" >
                            <div class="card-container">
                                <el-card class="top-card">
                                    <div class="card-content">
                                        <i class="el-icon-lx-timefill icon" ></i>
                                        <div class="text-content iconJump">
                                            <div class="card-value" v-animate-number="tsData.tsNum"></div>
                                            <div class="card-title">投诉量</div>
                                        </div>
                                    </div>
                                </el-card>
                                <div class="hover-layer"></div>
                            </div>
                        </el-col>
                        <el-col :span="12" >
                            <div class="card-container">
                                <el-card class="top-card">
                                    <div class="card-content">
                                        <i class="el-icon-s-help icon" ></i>
                                        <div class="text-content iconJump">
                                            <div class="card-value" >{{formatPercentage(tsData.tsPre)}}</div>
                                            <div class="card-title">投诉率</div>
                                        </div>
                                    </div>
                                </el-card>
                                <div class="hover-layer"></div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <div style='width:49%;float:right;' >
                    <h5 class='mb5'><i class='el-icon-lx-warnfill red size20'></i> 本月新增</h5>
                    <el-row  :gutter="5" type="flex" justify="space-between">
                        <el-col :span="12" >
                            <div class="card-container">
                                <el-card class="top-card">
                                    <div class="card-content">
                                        <i class="el-icon-lx-roundcheckfill icon" ></i>
                                        <div class="text-content iconJump">
                                            <div class="card-value" v-animate-number="tsData2.successNum"></div>
                                            <div class="card-title">订购量</div>
                                        </div>
                                    </div>
                                </el-card>
                                <div class="hover-layer"></div>
                            </div>
                        </el-col>
                        <el-col :span="12" >
                            <div class="card-container">
                                <el-card class="top-card">
                                    <div class="card-content">
                                        <i class="el-icon-lx-timefill icon" ></i>
                                        <div class="text-content iconJump">
                                            <div class="card-value" v-animate-number="tsData2.tsNum"></div>
                                            <div class="card-title">投诉量</div>
                                        </div>
                                    </div>
                                </el-card>
                                <div class="hover-layer"></div>
                            </div>
                        </el-col>
                        <el-col :span="12" >
                            <div class="card-container">
                                <el-card class="top-card">
                                    <div class="card-content">
                                        <i class="el-icon-s-help icon" ></i>
                                        <div class="text-content iconJump">
                                            <div class="card-value" >{{formatPercentage(tsData2.tsPre)}}</div>
                                            <div class="card-title">投诉率</div>
                                        </div>
                                    </div>
                                </el-card>
                                <div class="hover-layer"></div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <div style='clear:both'></div>
            </el-card>


<div class="chart-rows">
        <el-row v-loading="schartLoading" :gutter="2" style="margin-top: 2px;">
            <el-card class='mt5' >
                <div style='width:49%;padding-right:1%;float:left; border-right:1px dashed #ccc;'>
                    <div :style="{ height: chartHeight + 'px' }" id="echart1" class="echartswh"></div>
                </div>
                <div style='width:49%;float:right;' >
                    <div :style="{ height: chartHeight + 'px' }" id="echart2"  class="echartswh"></div>
                </div>
                <div style='clear:both'></div>
            </el-card>
            <el-card class='mt5'>
                <div style='width:49%;padding-right:1%;float:left;border-right:1px dashed #ccc; '>
                    <div class="echartswh1" v-loading="memloading1">
                        <span class='label6 mb5' style='float:right;margin-top:-15px'><i class='el-icon-lx-filter pointer' @click="selectGoods('1')"></i></span>
                        <div :style="{ height: chartHeight + 'px' }" style='margin-top:25px;' id="echart3" class="echartswh2"></div>
                    </div>
                </div>
                <div style='width:49%;float:right;' >
                    <div class="echartswh1" v-loading="memloading2">
                        <span class='label6 mb5' style='float:right;margin-top:-15px'><i class='el-icon-lx-filter pointer' @click="selectGoods('2')"></i></span>
                        <div :style="{ height: chartHeight + 'px' }" style='margin-top:25px;' id="echart4" class="echartswh2" ></div>
                    </div>
                </div>
                <div style='clear:both'></div>
            </el-card>
 
        </el-row>
</div>
        </template>
        <el-drawer title="产品筛选" :visible.sync="editVisible" direction="rtl" :append-to-body='true' width="500px" height="60%">
            <el-form ref="form1" :model="form1" label-width="120px">
                <el-radio-group v-if='goodsFag==1' @change='getChartDataByMem1' v-model.trim="form1.goodsCode1" >
                    <el-radio-button style='display:block;margin:5px 15px' label="0">全部产品</el-radio-button>
                    <el-radio-button style='display:block;margin:5px 15px;border:none' v-for="item in select.option" :label="item.optKey">{{ item.optVal }}</el-radio-button>
                </el-radio-group>
                <el-radio-group v-if='goodsFag==2' @change='getChartDataByMem2' v-model.trim="form1.goodsCode2" >
                    <el-radio-button style='display:block;margin:5px 15px' label="0">全部产品</el-radio-button><br>
                    <el-radio-button style='display:block;margin:5px 15px' v-for="item in select.option" :label="item.optKey">{{ item.optVal }}</el-radio-button>
                </el-radio-group>
            </el-form>
        </el-drawer>
    </div>
</template>

<script>
import {
    getShowNum,getChartDataByGoods,getChartDataByMem1,getChartDataByMem2
} from '../../../api/orderStatistics/tsShow';
import { fetchSelect3 as fetchSelect } from '../../../api/comGoods';
import * as echarts from 'echarts';
import numeral from 'numeral';
import { fetchSelect as fetchSelect1 } from '@/api/channelType';


export default {
    name: 'charts',
    data() {
        return {
            rowLoading: false,
            schartLoading: false,
            schartLoading1: false,
            channelLoading: false,
            productLoading: false,
            memloading2: false,
            memloading1: false,
            editVisible:false,
            lastTotalAvg: 0,
            refreshProgress: 100, // 初始进度为100%
            refreshCountdown: 10, // 初始倒计时为10秒
            refreshInterval: null,// 存储定时器ID
            chartHeight :160,
            form1:{goodsCode1:'0',goodsCode2:'0'},
            select:{option:''},
            tsData:{
                successNum:'',
                tsNum:'',
                tsPre:'',
            },
            query:{channelCode:'46'},
            tsData2:{
                successNum:'',
                tsNum:'',
                tsPre:'',
            },
            goodsFag:'1',
        };
    },

    beforeDestroy() {
    },
    created() {  },
    mounted() {
        this.initData();
        this.getChartData();
        this.getSelect();
    },
    computed: {  },
    methods: {
        // 编辑操作
        selectGoods(i) {
            this.goodsFag = i;
            this.editVisible = true;
        },
        formatCurrency(value) {
            return numeral(value).format('$0,0.00');
        },
        formatPercentage(value) {
            return numeral(value).format('0.00%');
        },
        initData(){
            this.rowLoading = true;
            let data = {};
            getShowNum(data).then(res => {
                this.rowLoading = false;
                if(res.code=='200'){
                    this.tsData = res.data.tsData;
                    this.tsData2 = res.data.tsData2;
                }else{
                    this.$message.error(res.message);
                }
            });
        },
        getChartData() {
            this.rowLoading = true;
            this.schartLoading = true;
            let data = {};
            getChartDataByGoods(data).then(res => {
                if (res.code == '200'){
                    this.initChart('echart1', '产品投诉', res.data.chartX1, res.data.chartY1_1,res.data.chartY1_2,res.data.chartY1_3);
                    this.initChart('echart2', '本月新增', res.data.chartX2, res.data.chartY2_1,res.data.chartY2_2,res.data.chartY2_3);
                }
                this.schartLoading = false;
            })
            this.getChartDataByMem1();
            this.getChartDataByMem2();
        },
        getChartDataByMem1(){
            let data = {};
            data.goodsCode = this.form1.goodsCode1;
            this.memloading1 = true;
            this.editVisible = false;
            getChartDataByMem1(data).then(res => {
                if (res.code == '200'){
                    this.initChart('echart3', '渠道投诉', res.data.chartX1, res.data.chartY1_1,res.data.chartY1_2,res.data.chartY1_3);
                    this.memloading1 = false;
                }
            })
        },
        getChartDataByMem2(){
            let data = {};
            data.goodsCode = this.form1.goodsCode2;
            this.memloading2 = true;
            this.editVisible = false;
            getChartDataByMem2(data).then(res => {
                if (res.code == '200'){
                    this.initChart('echart4', '本月新增', res.data.chartX1, res.data.chartY1_1,res.data.chartY1_2,res.data.chartY1_3);
                    this.memloading2 = false;
                }
            })
        },
        getSelect(){
            this.select = {};
            fetchSelect(this.select).then(res => {
                if(res.code=='200'){
                    this.$set(this.select, 'option', res.data);
                }
            });
        },
        initChart(id, title, categories, data1, data2, data3) {
            const chart = echarts.init(document.getElementById(id));
            const option = {
                title: {
                    text: title ,
                    textStyle: {
                        color: 'rgba(30,30,30,0.84)',
                        fontSize: 13
                    },
                    right: 'right',
                    top: 'top',
                    fontStyle: 'italic',
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    top: '5%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: categories,
                    axisTick: {
                        alignWithLabel: true
                    },
                    axisLabel: {
                        rotate: 30, // 旋转角度
                        interval: 0, // 强制显示所有标签
                        fontSize: 10,
                        formatter: function(value) {
                            // 或者超出长度显示省略号
                            return value.length > 12 ? value.substring(0,10)+'...' : value;
                        }
                    }
                },
                yAxis: {
                    type: 'value',

                },
                series: [{
                    name: '订购量',
                    type: 'bar',
                    color: 'rgb(239, 82, 105)',
                    data: data1
                },{
                    name: '投诉量',
                    type: 'bar',
                    color: 'rgb(250,185,20)',
                    data: data2
                },{
                    name: '投诉率',
                    type: 'bar',
                    color: 'rgb(250,124,20)',
                    data: data3
                }]
            };
            chart.setOption(option);
        }
        ,initChart3(id, title, categories, data) {
            const chart = echarts.init(document.getElementById(id));
            const option = {
                title: {
                    text: title ,
                    textStyle: {
                        color: 'rgba(128,142,230,0.84)',
                        fontSize: 14
                    },
                    right: 'right',
                    top: 'top',
                    fontStyle: 'italic',
                },
                tooltip: {
                    alwaysShowContent: true,
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                    formatter: function(params) {
                        // 打印 params 以查看其结构
                        console.log(params);
                        // 获取 X 轴的值
                        const xAxisValue = params[0].axisValue;

                        // 构建提示框内容
                        return `${xAxisValue}<br/>` + params.map(item => {
                            return `${item.seriesName}:  ${item.value}%`;
                        }).join('<br/>');
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    top: '10%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: categories,
                    axisTick: {
                        alignWithLabel: true
                    },
                    axisLabel: {
                        rotate: 30, // 旋转角度
                        interval: 0, // 强制显示所有标签
                        fontSize: 10,
                        formatter: function(value) {

                            // 或者超出长度显示省略号
                            return value.length > 5 ? value.substring(0,5)+'...' : value;
                        }
                    }
                },
                yAxis: {
                    type: 'value',

                },
                series: [{
                    name: title,
                    type: 'bar',
                    color: 'rgb(239, 82, 105)',
                    data: data
                }]
            };
            chart.setOption(option);
        }
        ,
        initChart1(id, title, categories, data,dataTitle,data2,data2Title) {
            const chart = echarts.init(document.getElementById(id));
            const option = {
                title: {
                    text: title,
                    textStyle: {
                        color: 'rgba(128,142,230,0.84)',
                        fontSize: 14
                    },
                    right: 'right',
                    top: 'top',
                    fontStyle: 'italic',},
                tooltip: {
                    show: true,
                    trigger: 'axis'
                },
                legend: {
                    data: [dataTitle,data2Title]
                },
                xAxis: {
                    data: categories,
                    axisLabel: {
                        rotate: 30, // 旋转角度
                        interval: 0 // 强制显示所有标签
                    }
                },
                yAxis: {},
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    top: '10%',
                    containLabel: true
                },
                series: [{
                    name: dataTitle,
                    type: 'line',
                    data: data,
                    color: '#e30627'
                },{
                    name: data2Title,
                    type: 'line',
                    data: data2,
                    color: '#089107'
                }
                ]
            };
            chart.setOption(option);
        }
        ,


        getIconClass(title) {
            const iconMap = {
                '今日订购量': 'el-icon-s-claim',
                '今日请求量': 'el-icon-lx-warnfill',
                '本周订购量': 'el-icon-lx-warnfill',
            };
            return iconMap[title] || '';
        },
    }
};

</script>


<style scoped>
.dashboard {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    padding: 5px;
}
.chart-rows {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
}

.card-container {
    width: 96%;
    margin: 0px 2%;
    position: relative;
    overflow: visible;
}

.top-card {
    height: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 5px 0;
    border-radius: 10px;
    background-color: rgba(255, 255, 255, 0.8);
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
    z-index: 2;
    position: relative;
}

.card-title {
    font-size: 12px;
    margin-top: 0; /* 移除顶部间距 */
    text-align: center;
    color:#666;
}
.card-title2 {
    font-size: 13px; 
    margin-top: 0; /* 移除顶部间距 */
    text-align: center; 
    color: #666;
}

.card-value {
    font-size: 15px;
    font-weight: bold; 
    margin-top: 5px;
    text-align: center;
    color: #666;
}
.card-value2 {
    font-size: 25px;
    font-weight: bold; 
    margin-top: 5px;
    text-align: center; 
    color: rgba(2, 174, 7, 0.8);
}

.el-col-4 {
    width: 16.6%;
}

.hover-layer {
    border-radius: 10px;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to right, #7ebcfd, #7ebcfd);
    transform: scale(0);
    transform-origin: center center;
    opacity: 0.6;
    transition: all 0.4s ease-in-out;
    z-index: 1;
    pointer-events: none;
}

.card-container:hover .hover-layer {
    transform: scale(1);
    opacity: 1;
}
.card-value span {
    font-weight: normal;
}

.card-value .positive {
    color: #2ecc71; /* 鲜亮绿色，表示增长 */
}

.card-value .negative {
    color: #e74c3c; /* 鲜艳红色，表示下降 */
}
.echartswh {
    padding:10px 2%;
    width: 96%;
    height: 100%; /* 自动继承父容器高度 */
    min-height: 180px; /* 最小高度兜底 */

}
.echartswh1{
    padding:10px 2%;
    width: 96%;
    height: 100%; /* 自动继承父容器高度 */
    min-height: 210px; /* 最小高度兜底 */
}
.echartswh2{
    width: 100%;
    height: 100%;
    min-height: 180px; /* 最小高度兜底 */
}

.icon {
    font-size: 45px;
    height: 100px;
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px; 
    vertical-align: middle;
    color: rgb(239, 82, 105);
}
.icon2 {
    font-size: 45px;
    height: 100px;
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
    vertical-align: middle;
    color: black;
}
.card-content {
    display: flex;
    align-items: center;
    padding: 10px; 
}
.text-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center; /* 确保文本居中对齐 */
}
@media (max-width: 768px) {
    .el-col-4 {
        width: 50%; /* 手机端两列显示 */
        margin-bottom: 10px;
    }
}
@media (min-width: 769px) and (max-width: 1024px) {
    .el-col-4 {
        width: 33.33%; /* 平板三列显示 */
    }
}

.el-row {
    margin-bottom: 2px !important;
}
.mt5{
    margin-top:5px !important;
} 
 /*
.card-content{
        内联元素（inline）动画不起作用， 因此要设置为‘inline-block’  
        animation: jump2 2s infinite ease-in-out;
        animation-delay: var(--delay);
      }

      @keyframes jump2 { 
        100% {
          transform: translateY(0);
        }
        50% {
          transform: translateY(-10px);
        }
      } */

      .iconJump2 {
            color: #409EFF;
            background-image: -webkit-linear-gradient(90deg, #409EFF, #01ac25);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            -webkit-animation: change2 5s infinite linear;
        }
        @-webkit-keyframes change2 {
            from {
            -webkit-filter: hue-rotate(0deg);
            }
            to {
            -webkit-filter: hue-rotate(-360deg);
            }
        } 

</style>
